package com.milta.feature.subscription.domain.entity

data class Subscription(
    val plan: SubscriptionPlan,
    val status: SubscriptionStatus,
    // null on a Trial row — the trial has no store platform/product behind it.
    val platform: String?,
    val storeProductId: String?,
    val expiresAt: String?,   // ISO 8601, null si durée indéterminée
)
